/* tslint:disable */
import {
  StockLocation,
  StockQuantPackage,
  StockProductionLot,
  Product,
  ProductUom
} from '../index';

declare var Object: any;
export interface StockQuantInterface {
  "id"?: number;
  "name"?: string;
  "location_id"?: number;
  "lot_id"?: number;
  "product_id"?: number;
  "product_uom_id"?: number;
  "quantity"?: number;
  "package_id"?: number;
  location?: StockLocation;
  package?: StockQuantPackage;
  lot?: StockProductionLot;
  product?: Product;
  productUom?: ProductUom;
}

export class StockQuant implements StockQuantInterface {
  "id": number;
  "name": string;
  "location_id": number;
  "lot_id": number;
  "product_id": number;
  "product_uom_id": number;
  "quantity": number;
  "package_id": number;
  location: StockLocation;
  package: StockQuantPackage;
  lot: StockProductionLot;
  product: Product;
  productUom: ProductUom;
  constructor(data?: StockQuantInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockQuant`.
   */
  public static getModelName() {
    return "StockQuant";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockQuant for dynamic purposes.
  **/
  public static factory(data: StockQuantInterface): StockQuant{
    return new StockQuant(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockQuant',
      plural: 'StockQuant',
      path: 'StockQuant',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "lot_id": {
          name: 'lot_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
        "quantity": {
          name: 'quantity',
          type: 'number'
        },
        "package_id": {
          name: 'package_id',
          type: 'number'
        },
      },
      relations: {
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        package: {
          name: 'package',
          type: 'StockQuantPackage',
          model: 'StockQuantPackage',
          relationType: 'belongsTo',
                  keyFrom: 'package_id',
          keyTo: 'id'
        },
        lot: {
          name: 'lot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'lot_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        productUom: {
          name: 'productUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockQuant.ts